import {
  PORTAL_ADMIN,
  PORTAL_DEPOSIT,
  PORTAL_EVENTS,
  PORTAL_PROJECTS,
  PUBLIC_DEPOSITS,
} from "@/app/router/portalRoutes"
import { isDepositsUiEnabled } from "@/features/deposits/depositsUiEnabled"

export type NavItemKey = "profile" | "events" | "projects" | "deposit" | "admin" | "about"

export const NAV_ITEMS = [
  { path: "/profile", key: "profile" as const },
  { path: "/events", key: "events" as const },
  { path: PORTAL_PROJECTS, key: "projects" as const },
  { path: PUBLIC_DEPOSITS, key: "deposit" as const },
  { path: PORTAL_ADMIN, key: "admin" as const },
  { path: "/about", key: "about" as const },
]

export const getNavItems = () =>
  isDepositsUiEnabled ? NAV_ITEMS : NAV_ITEMS.filter((item) => item.key !== "deposit")

const isEventsNavActive = (pathname: string) => {
  if (pathname === "/events" || pathname.startsWith("/events/")) return true
  if (pathname === PORTAL_EVENTS || pathname.startsWith(`${PORTAL_EVENTS}/`)) return true
  if (
    pathname === "/mycreatedevents" ||
    pathname === "/eventsmoderation" ||
    pathname === "/eventsregistrationmoderation" ||
    pathname === "/events/portal"
  ) {
    return true
  }
  return false
}

const isProjectsNavActive = (pathname: string) =>
  pathname === PORTAL_PROJECTS || pathname.startsWith(`${PORTAL_PROJECTS}/`)

const isDepositsNavActive = (pathname: string) =>
  pathname === PUBLIC_DEPOSITS ||
  pathname.startsWith(`${PUBLIC_DEPOSITS}/`) ||
  pathname === PORTAL_DEPOSIT ||
  pathname.startsWith(`${PORTAL_DEPOSIT}/`)

const isAdminNavActive = (pathname: string) => pathname === PORTAL_ADMIN || pathname.startsWith(`${PORTAL_ADMIN}/`)

const navActiveMatchers: Record<NavItemKey, (pathname: string) => boolean> = {
  profile: (pathname) => pathname === "/profile" || pathname.startsWith("/profile/"),
  events: isEventsNavActive,
  projects: isProjectsNavActive,
  deposit: isDepositsNavActive,
  admin: isAdminNavActive,
  about: (pathname) => pathname === "/about" || pathname.startsWith("/about/"),
}

export const isNavItemActive = (key: NavItemKey, pathname: string) => navActiveMatchers[key](pathname)
